import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { PartialRange } from 'features/valueObjects/Range'
import { YearBuiltFilterCardDumb } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/YearBuiltFilterCard/YearBuiltFilterCard.dumb'
import { YearBuiltFilterCardDumbProps as Props } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/YearBuiltFilterCard/YearBuiltFilterCard.dumb.props'
import { shallow } from 'zustand/shallow'

export const YearBuiltFilterCard = () => {
  const isReady = useCMAStore(state =>
    checkStateHasReportData(state.local.report),
  )

  const {
    subjectValue,
    filterValue,
  } = useCMAStore(state => {
    if (!checkStateHasReportData(state.local.report)) {
      return {
        subjectValue: null,
        filterValue: null,
      }
    }

    return {
      subjectValue: state.local.report.data.salesListInfo.subject?.yearBuilt ?? null,
      filterValue: state.local.report.data.filters.yearBuilt?.range ?? null,
    }
  }, shallow)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = range => {
    void filterComps({
      yearBuilt: {
        range,
      },
    })
  }

  if (!isReady) return null

  return (
    <YearBuiltFilterCardDumb
      value={filterValue || PartialRange.EMPTY}
      onChange={handleOnValueChange}
      subjectValue={subjectValue}
    />
  )
}
